/** Admin lists are re-read on demand; five minutes keeps filter flips and tab hops free. */
export const LIST_STALE_MS = 5 * 60_000;

/**
 * Centralised TanStack Query keys.
 * Use factory style so detail keys hang off list keys (`["users", "detail", uid]`).
 */
export const queryKeys = {
  kpis: ["kpis"] as const,
  users: {
    all: ["users"] as const,
    list: (filters: Record<string, unknown> | object) => ["users", "list", filters] as const,
    detail: (uid: string) => ["users", "detail", uid] as const,
  },
  charities: {
    all: ["charities"] as const,
    list: (filters: Record<string, unknown> | object) => ["charities", "list", filters] as const,
    detail: (id: string) => ["charities", "detail", id] as const,
  },
  schools: {
    all: ["schools"] as const,
    list: (filters: Record<string, unknown> | object) => ["schools", "list", filters] as const,
    detail: (urn: string) => ["schools", "detail", urn] as const,
  },
  categories: {
    all: ["categories"] as const,
    list: () => ["categories", "list"] as const,
  },
  customCategories: {
    all: ["customCategories"] as const,
    list: (filters: Record<string, unknown> | object) =>
      ["customCategories", "list", filters] as const,
  },
  items: {
    list: (filters: Record<string, unknown> | object) => ["items", "list", filters] as const,
    detail: (id: string) => ["items", "detail", id] as const,
  },
  tags: {
    all: ["tags"] as const,
    list: (filters: Record<string, unknown> | object) => ["tags", "list", filters] as const,
    detail: (id: string) => ["tags", "detail", id] as const,
  },
  tagBatches: {
    all: ["tagBatches"] as const,
    list: (filters: Record<string, unknown> | object) => ["tagBatches", "list", filters] as const,
  },
  tagOrders: {
    all: ["tagOrders"] as const,
    list: (filters: Record<string, unknown> | object) => ["tagOrders", "list", filters] as const,
  },
  claims: {
    list: (filters: Record<string, unknown> | object) => ["claims", "list", filters] as const,
    detail: (id: string) => ["claims", "detail", id] as const,
  },
  returns: {
    list: (filters: Record<string, unknown> | object) => ["returns", "list", filters] as const,
    detail: (id: string) => ["returns", "detail", id] as const,
  },
  foundItems: {
    list: (filters: Record<string, unknown> | object) => ["foundItems", "list", filters] as const,
  },
  postal: {
    all: ["postal"] as const,
    list: (filters: Record<string, unknown> | object) => ["postal", "list", filters] as const,
    detail: (id: string) => ["postal", "detail", id] as const,
  },
  referrals: {
    all: ["referrals"] as const,
    list: (filters: Record<string, unknown> | object) => ["referrals", "list", filters] as const,
  },
  pricingConfig: {
    all: ["pricingConfig"] as const,
  },
  opsAlerts: {
    all: ["opsAlerts"] as const,
    list: (filters: Record<string, unknown> | object) => ["opsAlerts", "list", filters] as const,
  },
  audit: {
    list: (filters: Record<string, unknown> | object) => ["audit", "list", filters] as const,
  },
  webhooks: {
    list: (filters: Record<string, unknown> | object) => ["webhooks", "list", filters] as const,
    detail: (id: string) => ["webhooks", "detail", id] as const,
    deliveries: (configId: string, filters: Record<string, unknown> | object) =>
      ["webhooks", "deliveries", configId, filters] as const,
  },
  apiKeys: {
    list: (filters: Record<string, unknown> | object) => ["apiKeys", "list", filters] as const,
    detail: (id: string) => ["apiKeys", "detail", id] as const,
    usage: (keyId: string, filters: Record<string, unknown> | object) =>
      ["apiKeys", "usage", keyId, filters] as const,
  },
  launchSubscribers: {
    all: ["launchSubscribers"] as const,
    list: (filters: Record<string, unknown> | object) =>
      ["launchSubscribers", "list", filters] as const,
  },
  catalog: {
    all: ["catalog"] as const,
  },
  promoCodes: {
    all: ["promoCodes"] as const,
    list: (filters: Record<string, unknown> | object) => ["promoCodes", "list", filters] as const,
    detail: (code: string) => ["promoCodes", "detail", code] as const,
  },
  returnAnalytics: {
    export: (filters: Record<string, unknown> | object) =>
      ["returnAnalytics", "export", filters] as const,
  },
};
